<template>
    <Dialog v-model:visible="visible" :style="{ width: '300px' }" :header="dialogHeader" :modal="true" class="p-fluid dialog-header" @hide="$emit('hide-dialog', true)">
        <div class="field">
            <label for="name">Source Name:</label>
            <InputText :class="{ 'p-invalid': submitted && !source.name }" id="name" type="text" v-model="source.name" autofocus />
            <small class="p-invalid" v-if="submitted && !source.name">Source Name is required</small>
        </div>
        <div class="field">
            <custom-tree-select v-model="source.parent_id" label="Parent Source" :optionsTree="sourceTree" />
            <Button v-if="source.parent_id" label="Remove Parent" icon="pi pi-trash" class="p-button-warning" @click="removeParent" />
        </div>

        <template #footer>
            <Button label="Cancel" icon="pi pi-times" class="p-button-danger" @click="visible = false" />
            <Button label="Submit" icon="pi pi-check" class="p-button-success" @click="submit" />
        </template>
    </Dialog>
</template>

<script setup>
import CustomTreeSelect from '../../../../../modules/custom-inputs/CustomTreeSelect.vue';
import { storeToRefs } from 'pinia';
import { ref, defineEmits, computed, onUnmounted } from 'vue';
import { object, string } from 'yup';
import { sourceStore } from '../../../../../store/global-stores';
import { showToast } from '../../../../../utilities/toast-handler';

// emit
const emit = defineEmits(['hide-dialog']);

const visible = ref(true);
const submitted = ref(false);

const { source, sourceTree, editId } = storeToRefs(sourceStore);

// computed properties starts
const dialogHeader = computed(() => {
    return editMode.value ? 'Update Existing Source' : 'Add New Source';
});

const editMode = computed(() => {
    return editId.value;
});

const validationSchema = object({
    name: string().required('Source Name is required'),
});

onUnmounted(() => {
    sourceStore.initSource();
});

const removeParent = () => {
    source.value.parent_id = null;
};

const submit = async () => {
    try {
        submitted.value = true;
        await validationSchema.validate(source.value, { abortEarly: false });
        const response = editMode.value ? await sourceStore.updateSource() : await sourceStore.createSource();
        if (response) {
            emit('hide-dialog');
        }
    } catch (error) {
        if (error.inner && typeof error.inner === 'object') {
            showToast({}, 'Input data invalid');
        }
    }
};
</script>
